import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/case-studies/mdrouz/ios.png";
import Img2 from "../../../images/case-studies/mdrouz/flutter.png";
import Img3 from "../../../images/case-studies/mdrouz/wordpress.png";
import Img4 from "../../../images/case-studies/mdrouz/aws.png";
import Img5 from "../../../images/case-studies/mdrouz/mysql.png";
import Img6 from "../../../images/case-studies/mdrouz/web-server.png";
import Img7 from "../../../images/case-studies/mdrouz/bootstrap.png";
import Img8 from "../../../images/case-studies/mdrouz/php.png";
import Img9 from "../../../images/case-studies/mdrouz/cloudfare.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Techcase = () => {
    return (
        <div className="tech_case p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="m-auto text-center">
                        <div className="tech_head">
                            <h2>Tech Stack <span>for Mdrouz</span></h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="tech_case_main">
                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>Mobile Platforms</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img1}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>Mobile App Development Framework</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img2}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>CMS (Content Management System)</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img3}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>Cloud</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img4}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>Database</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img5}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="line_tech"></div>
                        <div className="tech_case_main">
                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>Web Server</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img6}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>UI Frameworks</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img7}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>Programming languages</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img8}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_case_all">
                                <div className="tech_case-content">
                                    <h6>CDN</h6>
                                </div>
                                <div className="tech_case-img">
                                    <LazyLoadImage
                                        src={Img9}
                                        effect="blur" alt="TekRevol" className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Techcase